/**
 * 云服务类别 产品实例列表/实例图表页 告警策略Drawer中内容
 *
 * @format
 */

import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { _$, Button } from 'kpc-react'
import useGlobalData from 'src/hooks/useGlobalData'
import NoDataComponent from 'src/components/NoData'
import { DrawerProps } from 'src/pages/MonitorCloud/constants'
import { useHistory } from 'react-router'
import { request } from 'src/utils'
import API from 'src/api/ApiCloud'
const methodObject = {
  avg: '平均值',
  max: '最大值',
  min: '最小值',
  sum: '求和值'
}
const DrawerAlarmStrate: React.FC<DrawerProps> = ({
  visible,
  productType,
  instanceName,
  instanceId,
  className
}) => {
  const history = useHistory()
  const [describeAlarm, setDescribeAlarm] = useState([])
  const [productName, setProductName] = useState('')
  const productList = useGlobalData('productList')

  const getDescribeAlarm = async () => {
    const {
      data: { alarmPolicyList }
    } = await request(API.getInstancePolicy, {
      method: 'GET',
      data: {
        PageIndex: 1,
        PageSize: 999,
        ProductType: productType,
        InstanceId: instanceId
      }
    })
    setDescribeAlarm(alarmPolicyList || [])
  }

  useEffect(() => {
    if (visible && instanceId && productType !== undefined) {
      getDescribeAlarm()
    }
  }, [])

  // 在productList中查找对应的prodouctName
  const getNameFromProductList = () => {
    const product = (productList as any[]).find(item => {
      return productType === item.productType + ''
    })
    setProductName(product?.productName || '')
  }

  useEffect(() => {
    if (productList.length) {
      getNameFromProductList()
    }
  }, [productList])

  return (
    <div className={className}>
      <div className="header">
        <p className="text-overflow">{_$(instanceName)}</p>
        <Button
          onClick={event => {
            history.push(`/monitor/alarmServer/rule/create/${productType}`)
          }}
        >
          {_$('新建告警策略')}
        </Button>
      </div>
      <ul className="list">
        {describeAlarm && describeAlarm.length && !!productList.length ? (
          describeAlarm.map((item, index) => {
            const { policyId, policyName, triggerRules } = item
            return (
              <li key={policyId}>
                <div className="alarm-title">
                  <p>{_$(policyName)}</p>
                  <a
                    className="primary-color edit"
                    onClick={event => {
                      history.push(`/monitor/alarmServer/rule/detail/${policyId}`)
                    }}
                  >
                    {_$('编辑')}
                  </a>
                </div>
                <div className="alarm-main">
                  <p className="label">{_$('产品名称')}：</p>
                  <p className="centent">{productName}</p>
                </div>
                <div className="alarm-main">
                  <p className="label">{_$('告警规则')}：</p>
                  <div className="rule-centent">
                    {triggerRules?.length &&
                      triggerRules.map(
                        ({ triggerId, itemName, period, method, compare, triggerValue, units }) => {
                          return (
                            <p key={triggerId}>
                              {itemName} {parseInt(period)}
                              {_$('分钟')} {_$(methodObject[method])} {compare} {triggerValue}
                              {units}
                            </p>
                          )
                        }
                      )}
                  </div>
                </div>
              </li>
            )
          })
        ) : (
          <NoDataComponent />
        )}
      </ul>
    </div>
  )
}

export default styled(DrawerAlarmStrate)`
  p {
    margin-bottom: 0;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      width: 400px;
      font-size: 14px;
    }
  }
  .list {
    margin-top: 6px;
    li {
      background: #f5f5f9;
      padding: 16px;
      border-radius: 2px;
      margin-top: 16px;
      &:hover {
        .alarm-title .edit {
          opacity: 1;
        }
      }
      .alarm-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 5px;
        p {
          font-size: 14px;
          font-weight: 700;
          color: #262626;
        }
        .edit {
          opacity: 0;
          transition: opacity 0.15s ease-out;
        }
      }
      .alarm-main {
        display: flex;
        margin-top: 5px;
        .label {
          height: 18px;
        }
        div {
          p {
            margin-bottom: 6px;
            padding-right: 10px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            min-width: 50%;
          }
        }
      }
    }
  }
`
